'use strict';

import React from 'react';
import { browserHistory } from 'react-router';
import 'styles/Navigator.scss';

class NavigatorComponent extends React.Component {
  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this); // 打开选择列表
  }
  navigate() {
    if(this.props.callback){
      this.props.callback();
    }
    if(this.props.action==='top'){
      window.scrollTo(0, 0);
    }else if(this.props.action==='back'){
      if(this.props.path){
        browserHistory.push(this.props.path);
      }else{
        browserHistory.goBack();
      }
    }else if(this.props.action==='home'){
      if(this.props.path){
        browserHistory.push(this.props.path);
      }else{
        browserHistory.push('/')
      }
    }else if(this.props.action==='save'){
    }else if(this.props.action==='saved'){
    }else if(this.props.action==='consult'){
    }else if(this.props.action==='share'){
    }else if(this.props.action==='edit'){
    }else if(this.props.action==='plus'){
    }else{
      if(this.props.path){
        browserHistory.push(this.props.path);
      }else{
        browserHistory.goBack();
      }
    }
  }
  render() {
    let button;
    if(this.props.action==='top'){
      button = (<div><i className="fa fa-angle-up" aria-hidden="true"></i></div>)
    }else if(this.props.action==='back'){
      button = (<div><i className="fa fa-angle-left" aria-hidden="true"></i></div>)
    }else if(this.props.action==='home'){
      button = (<div><i className="fa fa-home" aria-hidden="true"></i></div>)
    }else if(this.props.action==='save'){
      button = (<div><i className="fa fa-heart" aria-hidden="true"></i></div>)
    }else if(this.props.action==='saved'){
      button = (<div><i className="fa fa-heart" style={{color:'red'}} aria-hidden="true"></i></div>)
    }else if(this.props.action==='consult'){
      button = (<div><i className="fa fa-comments" aria-hidden="true"></i></div>)
    }else if(this.props.action==='share'){
      button = (<div><i className="fa fa-share" aria-hidden="true"></i></div>)
    }else if(this.props.action==='edit'){
      button = (<div><i className="fa fa-pencil" aria-hidden="true"></i></div>)
    }else if(this.props.action==='plus'){
      button = (<div><i className="fa fa-plus" aria-hidden="true"></i></div>)
    }else{
      button = (<div><i className="fa fa-angle-left" aria-hidden="true"></i></div>)
    }

    let number = this.props.number;
    if(!number){number = 1;}
    let _class = {bottom:`${number * 50}px`};
    return (
      <div className="extension-component">
        <div onClick={this.navigate.bind(this)} className="navigator" style={_class}>
          {button}
        </div>
      </div>
    );
  }
}


// Uncomment properties you need
// NavigatorComponent.propTypes = {};
// NavigatorComponent.defaultProps = {};

export default NavigatorComponent;



// WEBPACK FOOTER //
// ./src/components/NavigatorComponent.js